import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 페이지별 스크롤 위치를 기억하고 관리하는 컴포넌트
 * - KeepAlive 페이지는 자연스럽게 스크롤이 유지되므로 관리하지 않음
 * - 일반 페이지만 스크롤 위치를 저장/복원
 */
export default function ScrollManager() {
  const location = useLocation();
  const scrollPositions = useRef<{ [key: string]: number }>({});
  const prevLocation = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    
    // KeepAlive로 관리되는 페이지들 (이 페이지들은 자연스럽게 스크롤이 유지됨)
    const keepAlivePages = ['/'];
    
    // KeepAlive 페이지로 이동하는 경우, 스크롤을 건드리지 않음
    if (keepAlivePages.includes(currentPath)) {
      // 다만 이전 페이지가 일반 페이지였다면 그 스크롤 위치는 저장
      if (prevLocation.current && !keepAlivePages.includes(prevLocation.current)) {
        scrollPositions.current[prevLocation.current] = window.scrollY;
      }
      prevLocation.current = currentPath;
      return; // 스크롤 조작 없이 종료
    }
    
    // 이전 페이지의 스크롤 위치 저장 (KeepAlive 페이지가 아닌 경우에만)
    if (prevLocation.current && !keepAlivePages.includes(prevLocation.current)) {
      scrollPositions.current[prevLocation.current] = window.scrollY;
    }
    
    // 현재 페이지의 스크롤 위치 복원 (없으면 0)
    const savedPosition = scrollPositions.current[currentPath] || 0;
    
    // 스크롤 위치를 다음 렌더 사이클에서 설정 (DOM이 업데이트된 후)
    setTimeout(() => {
      window.scrollTo(0, savedPosition);
    }, 0);
    
    prevLocation.current = currentPath;
  }, [location.pathname]);

  return null;
}
